/** تزریق JSON-LD ساخت‌یافته (GEO/AEO) — فراخوانی مستقیم در بدنه رندر، آیدم‌پوتنت. */
export function setJsonLd(id, obj) {
  if (!obj) return;
  try {
    let el = document.querySelector(`script[data-ld="${id}"]`);
    const txt = JSON.stringify(obj);
    if (el) { if (el.textContent !== txt) el.textContent = txt; return; }
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.setAttribute('data-ld', id);
    el.textContent = txt;
    document.head.appendChild(el);
  } catch {}
}

export const siteOrigin = () => {
  try { return window.location.origin; } catch { return ''; }
};
